import React, { useCallback, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import TiptapEditor from "../../../../components/tiptap-editor/TiptapEditor";
import { sanitizeRichText, showToast } from "../../../../utils/utils";
import {
  CREDIT_DECISION_NOTES_SECTION,
  showToastType
} from "../../../../utils/constants/appConstants";
import { tiptapEditor } from "../../../../locales/en";
import privateAxios from "../../../../utils/axiosPrivate";
import { getReportingUpdateSalesChecklistCommentUrl } from "../../../../utils/constants/apiEndPoints";

const CreditDecisionNotes = ({ userId, salesAdditionalNote }) => {
  const [creditNotes, setCreditNotes] = useState("");
  const savedNotesRef = useRef("");

  const saveNotes = useCallback(
    async (content) => {
      if (content === savedNotesRef.current) return;
      try {
        const response = await privateAxios.post(
          getReportingUpdateSalesChecklistCommentUrl(userId),
          {
            section: CREDIT_DECISION_NOTES_SECTION,
            note: sanitizeRichText(content)
          }
        );
        showToast(response?.data?.message, showToastType.success);
        savedNotesRef.current = content;
      } catch (error) {
        showToast(error?.message, showToastType.error);
      }
    },
    [userId]
  );

  useEffect(() => {
    const creditNote = salesAdditionalNote?.find(
      (note) => note.section === CREDIT_DECISION_NOTES_SECTION
    );
    if (!creditNote) return;

    const noteContent = creditNote.note || "";
    setCreditNotes(noteContent);
    savedNotesRef.current = noteContent;
  }, [salesAdditionalNote]);

  return (
    <TiptapEditor
      value={creditNotes}
      onChange={setCreditNotes}
      onBlur={saveNotes}
      placeholder={tiptapEditor.creditNotesPlaceholder}
      ariaLabel={tiptapEditor.creditNotesLabel}
    />
  );
};

CreditDecisionNotes.propTypes = {
  userId: PropTypes.any.isRequired,
  salesAdditionalNote: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string,
      note: PropTypes.string
    })
  )
};

export default CreditDecisionNotes;
